export default __webpack_public_path__ + "static/media/udemy.c1ce3d52.png";